<carousel
  #productCarousel="carousel"
  [borderRadius]="10"
  [cellsToShow]="1"
  [lightDOM]="true"
  [objectFit]="'contain'"
  class="productCarousel"
  >
  @for (additionalImage of additionalImagesInCorrectOrder(); track additionalImage; let i = $index) {
    <div
      class="carousel-cell"
      >
      <div
        [description]="getImageAltTitle(i, false)"
        [imageFormat]="imageFormat"
        [image]="additionalImage"
        class="product-detail_carousel-image"
        render-product-image
      ></div>
    </div>
  }
</carousel>
